import React from 'react';
import css from './Footer.module.scss';


/**
 * @class
 *
 * The footer found throughout the app.
 *
 * This component is automatically included in views/pages once the user successfully logs in.
 * All links, text, etc. are hard-coded; updating them requires manually changing them here.
 */
const Footer = (props) => {
    return (
        <footer className={css.Footer}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <h1>Follow</h1>
                        <ul>
                            <li><a className="link-underline" href="https://www.instagram.com/v3sales/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                            <li><a className="link-underline" href="https://www.facebook.com/v3electric" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                            <li><a className="link-underline" href="https://twitter.com/v3electric" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                        </ul>
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <h1>Contact</h1>
                        <ul>
                            <li><a className="link-underline" href="tel:8448376937" rel="noopener noreferrer">844-V3POWER</a></li>
                            <li><a className="link-underline" href="mailto:info@v3electric.com" rel="noopener noreferrer">info@v3electric.com</a></li>
                            <li>
                                <a className="link-underline" href="https://goo.gl/maps/cJctgAjypF32" rel="noopener noreferrer">4925 Robert J Mathews Pkwy<br />El Dorado Hills, CA 95762</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <h1>V3 Electric</h1>
                        <ul>
                            <li><a className="link-underline" href="https://www.v3electric.com/v3/" target="_blank" rel="noopener noreferrer">About</a></li>
                            <li><a className="link-underline" href="http://www.v3careers.com/" target="_blank" rel="noopener noreferrer">Careers</a></li>
                            <li><a className="link-underline" href="http://www.v3university.com/" target="_blank" rel="noopener noreferrer">V3 University</a></li>
                            <li>
                                <a className="link-underline" href="http://webapp.getthereferral.com/#/?appCode=V3E117&companyCode=8560&companyName=V3%20Electric"
                                   target="_blank" rel="noopener noreferrer">Referral Program</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
